/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SamPolicyRequiredFieldsResponseDto } from '../models/sam-policy-required-fields-response-dto';


/**
 * the PolicyRequiredFields API
 */
@Injectable({
  providedIn: 'root',
})
export class PolicyRequiredFieldsService extends BaseService {
  constructor(
    config: SalesApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getRequiredFields
   */
  static readonly GetRequiredFieldsPath = '/policy/required-fields';

  /**
   * Get policy required fields
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRequiredFields()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRequiredFields$Response(params: {

    /**
     * Caller
     */
    caller: 'API' | 'FEC';
    productCode: string;
    variantCode?: string;
    offerId?: string;
    employeeCode?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SamPolicyRequiredFieldsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PolicyRequiredFieldsService.GetRequiredFieldsPath, 'get');
    if (params) {
      rb.query('caller', params.caller, {});
      rb.query('productCode', params.productCode, {});
      rb.query('variantCode', params.variantCode, {});
      rb.query('offerId', params.offerId, {});
      rb.query('employeeCode', params.employeeCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SamPolicyRequiredFieldsResponseDto>;
      })
    );
  }

  /**
   * Get policy required fields
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRequiredFields$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRequiredFields(params: {

    /**
     * Caller
     */
    caller: 'API' | 'FEC';
    productCode: string;
    variantCode?: string;
    offerId?: string;
    employeeCode?: string;
  },
  context?: HttpContext

): Observable<SamPolicyRequiredFieldsResponseDto> {

    return this.getRequiredFields$Response(params,context).pipe(
      map((r: StrictHttpResponse<SamPolicyRequiredFieldsResponseDto>) => r.body as SamPolicyRequiredFieldsResponseDto)
    );
  }

}
